/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommunicationService } from "../communication.service";
import { HttpMethods } from "../../models/ui/http-methods.model";
import { ENDPOINT_GROUPS } from "../../utils/apis/apis.constants";

@Injectable({
	providedIn: "root"
})
export class WhatIfSimulationHttpService {
	private _whatIfSimulationOperations = ENDPOINT_GROUPS.whatIfSimulation.operations;

	constructor(private _communicationService: CommunicationService) {}

	/**
	 * Runs a simulation for a given scenario and tenant.
	 *
	 * @param {string} scenarioId - The ID of the scenario to run the simulation for.
	 * @param {string} tenantId - The ID of the tenant for which the simulation is run.
	 * @returns An observable containing a message indicating the result of the simulation.
	 */
	public runSimulation(scenarioId: number, tenantId: string): Observable<string> {
		const params = new HttpParams({
			fromObject: {
				tenantId
			}
		});

		const pathParams = { scenarioId };

		return this._communicationService.callService(
			this._whatIfSimulationOperations.runSimulation.service,
			HttpMethods.POST,
			{ params, pathParams }
		);
	}
}
